import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { TenantsService } from 'src/app/services/tenants.service';
// import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrl: './register.component.scss',
})
export class RegisterComponent {
  email: string = '';
  accountNumber: string = '';
  zipcode: string = '';

  verifyingInfo = false;
  infoVerified = false;

  errorType?:
    | 'invalidAccountNumber'
    | 'invalidZipCode'
    | 'invalidInfo'
    | 'userExists'
    | 'unexpectedError';

  constructor(
    private authService: AuthService,
    private router: Router,
    private tenantsService: TenantsService
  ) {
    this.authService.authReady.subscribe((authReady) => {
      if (authReady && this.signedIn) {
        // user is already signed in, redirect to home
        this.authService.isInSignUpFlow = false;
        this.router.navigate(['']);
      }
    });
  }

  get signedIn() {
    return this.authService.signedIn;
  }

  verifyAndInviteUser() {
    this.errorType = undefined;
    this.verifyingInfo = false;
    if (!this.verifyAccountNumber(this.accountNumber)) {
      this.errorType = 'invalidAccountNumber';
      return;
    }

    if (!this.verifyZipCode(this.zipcode)) {
      this.errorType = 'invalidZipCode';
      return;
    }

    this.verifyingInfo = true;
    this.tenantsService
      .verifyAndInviteUser(this.accountNumber, this.email, this.zipcode)
      .subscribe({
        next: (res) => {
          console.log('User verified and invited: ', res);
          this.verifyingInfo = false;
          this.infoVerified = true;
        },
        error: (err) => {
          console.error(err);
          this.verifyingInfo = false;
          this.infoVerified = false;

          if (err.status === 400) {
            if (err.error.error === 'user info not valid') {
              this.errorType = 'invalidInfo';
            } else if (err.error.error === 'user already exists') {
              this.errorType = 'userExists';
            }
          } else {
            this.errorType = 'unexpectedError';
          }
        },
      });
  }

  verifyAccountNumber(accountNumber: string) {
    return this.tenantsService.validateAccountNumber(accountNumber);
  }

  verifyZipCode(zipcode: string) {
    return /^\d{5}(-\d{4})?$|^[a-z]\d[a-z] ?\d[a-z]\d$/i.test(zipcode);
  }
}
